import QRCode from 'qrcode';
import { createElement } from '../../adapters/dom';

export interface RenderQrCodeOptions {
  value: string;
  size?: number;
  alt?: string;
  className?: string;
}

export async function renderQrCode(options: RenderQrCodeOptions): Promise<HTMLImageElement> {
  const size = options.size ?? 220;
  const alt = options.alt ?? 'QR code';
  const className = options.className ?? 'cpw-qr-image';

  const img = createElement('img', {
    className,
    attributes: {
      alt,
      width: String(size),
      height: String(size)
    }
  }) as HTMLImageElement;

  img.src = await QRCode.toDataURL(options.value, {
    width: size,
    margin: 1
  });

  return img;
}